angular.module('project')
    .component('projectAssetGroups', {
        bindings: {
            items: '<',
            showNone: '<'
        },
        template: `
            <div class="asset-groups" style="display: inline-block;">
                <span ng-repeat="item in $ctrl.items" uib-tooltip="{{item.notes}}" ng-class="{ 'cursor-help': item.notes != null }">{{item.name}}{{$last ? '' : ', '}}</span>
                <span ng-if="$ctrl.showNone === true && $ctrl.items.length === 0" class="help-inline">brak</span>
            </div>
        `
    })
    .component('projectAssetGroupsLabel', {
        bindings: {
            items: '<',
            showNone: '<'
        },
        template: `
           <div style="flex-wrap: wrap; gap: 3px; display: inline-flex;">
                <span ng-if="$ctrl.showNone === true && $ctrl.items.length === 0" class="help-inline">brak</span>
                <span class="label label-default" ng-repeat="g in $ctrl.items track by $index" uib-tooltip="{{g.notes}}" ng-class="{ 'cursor-help': g.notes != null }" style="font-size: 90%; display: inline-block; padding: 0.3em 0.8em; background-color: forestgreen;">{{g.name}}</span>
            </div>
        `
    })


